<div class="home-slider">
    <div class="centerWidth">
        <div class="title" [innerHTML]="title_section['text1']">
            <!--        <div class="home-slider-title">-->
            <!--            <span >پلتفرم</span> &nbsp;-->
            <!--            <span class="gradiant">جستجو و دیسکاوری</span>-->
            <!--            <br><span >مبتنی بر هوش مصنوعی</span>-->
            <!--        </div>-->
            <!--        <div class="home-slider-title-2">-->
            <!--            <span >جستجو راحت‌تر، سریع‌تر و دقیق‌تر برای وب‌سایت‌ها و اپلیکیشن‌ها</span>-->
            <!--        </div>-->
        </div>
        <div class="register-btn">
            <a target="_blank" [href]="performanc!=null ?performanc['url']:'#'">
                <span i18n="@@Start Free">Start Free</span>
                <i *ngIf="getDirection() =='rtl'" class="pi pi-angle-left"></i>
                <i *ngIf="getDirection() =='ltr'" class="pi pi-angle-right"></i>
            </a>
        </div>
    </div>
    <div>
        <div class="business-slider">
            <div class="busi-icon">
                <app-bottom-slider></app-bottom-slider>
            </div>
        </div>
        <div class="caps1"></div>
        <div class="caps2"></div>
    </div>
</div>